(function () {
  function initShopTheLook(wrapper) {
    // Évite d'initialiser deux fois le même widget (navigation InstantClick).
    if (wrapper.dataset.stlReady === '1') return;
    wrapper.dataset.stlReady = '1';

    const addBtn = wrapper.querySelector('[data-add-look-btn]');
    const errorEl = wrapper.querySelector('[data-look-error]');
    const groups = wrapper.querySelectorAll('[data-product-id]');

    // Charge les variantes de chaque produit
    const variantsByProduct = {};
    groups.forEach(group => {
      const pid = group.dataset.productId;
      const jsonEl = group.querySelector(`[data-variants-json="${pid}"]`);
      try {
        variantsByProduct[pid] = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      } catch (e) {
        variantsByProduct[pid] = [];
      }
    });

    // Trouve la variante correspondant aux options sélectionnées
    function findVariant(group) {
      const pid = group.dataset.productId;
      const variants = variantsByProduct[pid] || [];
      const optionGroups = group.querySelectorAll('[data-option-index]');

      // Produit sans options (taille unique) : une seule variante
      if (optionGroups.length === 0) return variants[0] || null;

      const selected = [];
      for (const og of optionGroups) {
        const checked = og.querySelector('input:checked');
        if (!checked) return null;
        selected.push(checked.value);
      }

      return variants.find(v =>
        v.options.length === selected.length &&
        v.options.every((opt, i) => opt === selected[i])
      ) || null;
    }

    // Grise les options qui mènent à une variante indisponible
    function updateAvailability(group) {
      const pid = group.dataset.productId;
      const variants = variantsByProduct[pid] || [];
      const optionGroups = group.querySelectorAll('[data-option-index]');

      optionGroups.forEach((og, gIndex) => {
        og.querySelectorAll('input').forEach(input => {
          const testOptions = [];

          optionGroups.forEach((otherOg, oIndex) => {
            if (oIndex === gIndex) {
              testOptions[oIndex] = input.value;
            } else {
              const checked = otherOg.querySelector('input:checked');
              testOptions[oIndex] = checked ? checked.value : null;
            }
          });

          const hasMatch = variants.some(v =>
            v.available &&
            v.options.every((opt, i) => testOptions[i] === null || opt === testOptions[i])
          );

          input.disabled = !hasMatch;
          if (!hasMatch && input.checked) input.checked = false;
        });
      });
    }

    function checkReady() {
      const allValid = Array.from(groups).every(g => {
        const v = findVariant(g);
        return v && v.available;
      });
      addBtn.disabled = !allValid;
    }

    wrapper.addEventListener('change', () => {
      groups.forEach(updateAvailability);
      checkReady();
    });

    // État initial
    groups.forEach(updateAvailability);
    checkReady();

    addBtn.addEventListener('click', async () => {
      errorEl.hidden = true;

      const items = [];
      for (const group of groups) {
        const variant = findVariant(group);
        if (!variant) {
          errorEl.hidden = false;
          return;
        }
        items.push({ id: variant.id, quantity: 1 });
      }

      addBtn.disabled = true;
      const originalText = addBtn.textContent;
      addBtn.textContent = 'Ajout en cours…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) throw new Error('Cart add failed');

        window.location.href = '/cart';
      } catch (err) {
        errorEl.hidden = false;
        addBtn.disabled = false;
        addBtn.textContent = originalText;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-shop-the-look]').forEach(initShopTheLook);
  }

  // Lance tout de suite si la page est déjà chargée (cas InstantClick),
  // sinon attend la fin du chargement.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();